export default __webpack_public_path__ + "static/media/rewards.ea22a4ea.png";